/**
 * Itens do menu do cliente — fonte única do menu lateral (desktop, Figma —
 * out/2026) e do menu que abre de lado no celular. Antes os links do desktop
 * ficavam na barra superior e a lista era repetida nos dois lugares.
 */
import React from 'react';
import { BiSolidDashboard } from 'react-icons/bi';
import { MdHomeWork } from 'react-icons/md';
import {
  BsBarChartFill,
  BsPiggyBankFill,
  BsStarFill,
  BsPlugFill,
  BsQuestionCircleFill,
} from 'react-icons/bs';
import { PiLeafDuotone } from 'react-icons/pi';

import { useAppSelector } from 'store/hooks';
import * as selectUser from 'store/user/user.selector';
import { canAccessEmissionsReport } from 'utils/planRules';

export interface MenuItemDef {
  to: string;
  label: string;
  icon: React.ReactNode;
  /** Prefixo que marca o item como ativo (ex.: as rotas de Ajuda). */
  match?: string;
}

export const useClientMenuItems = (): MenuItemDef[] => {
  const user = useAppSelector(selectUser.currentUser);
  const isImpersonating = useAppSelector(selectUser.isImpersonating);
  // Relatório de emissões: só Enterprise (e admin) — o backend também recusa
  const showEmissions =
    !!user?.isAdmin ||
    isImpersonating ||
    canAccessEmissionsReport(user?.plan?.name ?? '');

  return [
    { to: '/dashboard', label: 'Dashboard', icon: <BiSolidDashboard /> },
    {
      to: '/unidades-consumidoras',
      label: 'Meus imóveis',
      icon: <MdHomeWork />,
    },
    { to: '/analises', label: 'Análises', icon: <BsBarChartFill /> },
    ...(showEmissions
      ? [
          {
            to: '/relatorio-emissoes',
            label: 'Emissões',
            icon: <PiLeafDuotone />,
          },
        ]
      : []),
    {
      to: '/oportunidades-economia',
      label: 'Oportunidades',
      icon: <BsPiggyBankFill />,
    },
    {
      to: '/servicos-adicionais',
      label: 'Serviços adicionais',
      icon: <BsStarFill />,
    },
    { to: '/integracoes', label: 'Integrações', icon: <BsPlugFill /> },
    {
      to: '/ajuda/como-obter-fatura-em-pdf',
      label: 'Ajuda',
      icon: <BsQuestionCircleFill />,
      match: '/ajuda',
    },
  ];
};
